import CanvasBase from "../../../../../ui/canvases/CanvasBase";
import goalScoreAreaImage from "../../../../../../assets/img/demo/goal-score-area-image@2.png";
import {complex} from "mathjs";
import React from "react";

/**
 Goal Score Area
 Draws shots on goal score area.

 Goal:
 x: [-160, 160]
 Z: [-75, 75]

 Shot:
 x: [-235, 235]
 Z: [-150, 150]
 */
class GoalScoreArea extends CanvasBase {
    constructor(props) {
        super(props);
        this.handleCanvasBackgroundLoaded = this.handleCanvasBackgroundLoaded.bind(this);
    }

    /**
     * Initialize background of canvas.
     * @override Draw images from center of canvas.
     * @return {void}
     */
    initBackground() {
        const {scoreArea} = this.canvasConfig();
        const imageObject = new Image();
        const {width, height} = scoreArea;
        const background = this.canvasBackground();
        const {handleCanvasBackgroundLoaded} = this;

        imageObject.src = background;
        imageObject.onload = () => {
            this.drawImage(complex(0, 0), background, width, height, () => {
                if (typeof handleCanvasBackgroundLoaded === 'function') {
                    handleCanvasBackgroundLoaded();
                }
            });
        };
    }


    /**
     * Returns image of the score area.
     * @returns {string}
     */
    goalScoreAreaImage = () => goalScoreAreaImage;

    /**
     * Returns background of the canvas.
     * @override
     * @returns {string}
     */
    canvasBackground() {
        return this.goalScoreAreaImage();
    }

    /**
     * Handler fire after load canvas background.
     * @override
     * @returns {void}
     */
    handleCanvasBackgroundLoaded() {
        const {shotsOnTarget} = this.props;
        const accurateColor = '#2B82F7';
        const missedColor = '#F96274';

        const shots = shotsOnTarget.map((shot) => {
            const {to, type} = shot;
            return {
                x: to.x,
                z: to.z,
                color: type === 'accurate' ? accurateColor : missedColor,
            };
        });

        this.drawShotsOnTarget(shots);
        // this.drawFilledCircle(complex(0, 0), 50, {});
    }

    /**
     * Draws the balls on the goal score area.
     * @param shots {array} The shots will be drown.
     * @return {void}
     */
    drawShotsOnTarget(shots) {
        shots.forEach((shot) => {
            this.drawShotOnTarget(shot);
        });
    }

    /**
     * Draws the balls on the goal score area.
     * @param shot {{x: integer, y: integer, color: string}} The x-coordinate, y-coordinate and color of the shot will be drown.
     * @return {void}
     */
    drawShotOnTarget(shot) {
        const {scoreArea} = this.canvasConfig();
        const {ball: ballConfig} = scoreArea;
        const {size} = ballConfig;
        const {x, z, color} = shot;
        const o = complex(x, z);

        const config = {
            strokeStyle: color,
            fillStyle: color,
        };
        this.drawFilledCircle(o, size, config);
    }


    baseConfig = () => ({
        // The width of component.
        width: 340,
        // The resolution of canvas.
        resolution: {
            width: 470,
            height: 300,
        },
        // The width and height of goal score area within canvas, size and color of ball in canvas.
        scoreArea: {
            width: 320,
            height: 150,
            ball: {
                size: 4,
                color: 15,
            },
        },
        line: {
            width: 14,
            dash: 8,
            space: 16,
            arrowHead: {
                length: 6,
                filled: true,
                closed: true,
            },
        },
        strokeStyle: `${this.strokeStyle()}`,
        fillStyle: `${this.fillStyle()}`,
    });

    /**
     * @override
     * @param x {float} The x-coordinate.
     * @returns {float} The x-coordinate after apply offset.
     */
    offsetX = (x) => {
        const {resolution} = this.canvasConfig();
        const {width} = resolution;

        return x + width / 2
    };

    /**
     * @override
     * @param z {float} The z-coordinate.
     * @returns {float} The z-coordinate after apply offset.
     */
    offsetY = (z) => {
        const {resolution} = this.canvasConfig();
        const {height} = resolution;

        return -z + height / 2
    };

    /**
     *
     * @param z {float} The z-coordinate.
     * @returns {float} The z-coordinate after apply offset.
     */
    offsetZ = (z) => {
        const {resolution} = this.canvasConfig();
        const {height} = resolution;

        return -z + height
    };


    strokeStyle = () => '#000000';
    fillStyle = () => '#FFFFFF';

    canvasStyle = () => {
        return {height: '267px'};
    };
}

export default GoalScoreArea;
